import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconChat = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 14 14",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M1.4 1.3125C0.627813 1.3125 0 1.94031 0 2.7125V6.9125C0 7.68469 0.627813 8.3125 1.4 8.3125H2.1V9.3625C2.1 9.49594 2.17438 9.61625 2.2925 9.67531C2.41063 9.73437 2.55281 9.72125 2.66 9.6425L4.43406 8.3125H7.7C8.47219 8.3125 9.1 7.68469 9.1 6.9125V2.7125C9.1 1.94031 8.47219 1.3125 7.7 1.3125H1.4ZM7.7 9.0125H5.6V9.7125C5.6 10.4847 6.22781 11.1125 7 11.1125H9.56594L11.34 12.4425C11.445 12.5212 11.5872 12.5344 11.7075 12.4753C11.8278 12.4162 11.9 12.2959 11.9 12.1625V11.1125H12.6C13.3722 11.1125 14 10.4847 14 9.7125V5.5125C14 4.74031 13.3722 4.1125 12.6 4.1125H9.8V6.9125C9.8 8.07187 8.85937 9.0125 7.7 9.0125Z",
		fill: "currentColor"
	})
});
export default SvgNavIconChat;
